import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, center }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C85A32]">
        {eyebrow}
      </span>
    )}
    <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-serif tracking-tight text-stone-900 leading-tight">
      {title}
    </h2>
    {subtitle && <p className="mt-4 text-base sm:text-lg text-stone-600 leading-relaxed">{subtitle}</p>}
  </div>
);
